import { connect } from 'react-redux';
import { fetchInventoryPackagesAvailability } from '../../../redux/Inventory/sagas/package/routines';
import {
  getIsFetching as getIsFetchingItems,
  getIsFetched as getIsFetchedItems,
  getOrder
} from '../../../redux/Inventory/selectors/package/availability';
import {
  clearInventoryPackagesAvailability,
  inventoryPackagesAvailabilityOnChangePage,
  inventoryPackagesAvailabilityOnChangeOrder
} from '../../../redux/Inventory/actions/package';
import {
  getPaginationLoadedPages,
  getPaginationWithoutPages,
  getPaginationQueryOptions,
  getCurrentPageItems
} from '../../../redux/Inventory/selectors/package/availability-pagination';
import { getSearchQueryForContext } from '../../../redux/Inventory/selectors/components/search';
import paginationAndSearchQuery from '../../../helpers/paginationAndSearchQuery';
import { PackageType } from '../../../constants/inventory/InventoryTypes';
import SEARCH_CONTEXT from '../../../helpers/InventorySearchContext';
import AvailabilityList from '../../../components/inventory/AvailabilityList';
import orderList from '../../../helpers/orderList';

function mapStateToProps(state) {
  const paginationQuery = getPaginationQueryOptions(state);
  const searchQuery = getSearchQueryForContext(
    state,
    SEARCH_CONTEXT.PACKAGE_AVAILABILITY
  );
  const order = getOrder(state);

  return {
    type: PackageType,
    items: orderList(order, getCurrentPageItems(state)),
    query: { ...paginationAndSearchQuery(paginationQuery, searchQuery), order },
    loadedPages: getPaginationLoadedPages(state),
    pagination: getPaginationWithoutPages(state),
    isFetching: getIsFetchingItems(state),
    isFetched: getIsFetchedItems(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: query => {
      dispatch(fetchInventoryPackagesAvailability(query));
    },
    onChangePage: (query, isPageLoaded) => {
      const { page } = query;
      if (!isPageLoaded) dispatch(fetchInventoryPackagesAvailability(query));
      else dispatch(inventoryPackagesAvailabilityOnChangePage(page));
    },
    onChangeLimit: query => {
      dispatch(clearInventoryPackagesAvailability());
      dispatch(fetchInventoryPackagesAvailability(query));
    },
    onSort: (sortBy, sortOrder, query) => {
      const order = `${sortBy}:${sortOrder}`;
      dispatch(clearInventoryPackagesAvailability());
      dispatch(fetchInventoryPackagesAvailability({ ...query, order }));
      dispatch(inventoryPackagesAvailabilityOnChangeOrder(order));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AvailabilityList);
